/**
 * Site reviews: write modal, photo compress/upload preview, lightbox, submit.
 * Auto fields (product_id / sku / asin / title) come from [data-fp-sr] dataset.
 */
(function () {
  var root = null;
  var modal = null;
  var form = null;
  var ratingInput = null;
  var photos = [];
  var maxPhotos = 8;

  function isVideoUrl(url) {
    return /\.(mp4|webm|mov|m4v)(?:[?#]|$)/i.test(String(url || ''));
  }
  var submitting = false;
  var viewer = null;
  var viewerPhotos = [];
  var viewerIndex = 0;
  var viewerTouchX = 0;
  var viewerSwipeAt = 0;

  var STAR_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 3.1c.28 0 .54.16.67.42l2.02 4.1 4.52.66c.192.168.1.3.39 1.05 0 .28-.1.54-.32.73l-3.27 3.19.77 4.5c.06.36-.09.72-.39.93-.3.22-.7.24-1.02.07L12 16.9l-4.04 2.12c-.32.17-.72.15-1.02-.07-.3-.21-.45-.57-.39-.93l.77-4.5-3.27-3.19c-.22-.19-.32-.45-.32-.73 0-.32.2-.61.5-.71l4.52-.66 2.02-4.1c.13-.26.39-.42.67-.42z"></path></svg>';

  var VERIFIED_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 1.6 13.5 3.2l1.9-.7 1 1.8 2 .4.3 2 1.8 1-.7 1.9L21.4 12l-1.6 1.5.7 1.9-1.8 1-.3 2-2 .4-1 1.8-1.9-.7L12 22.4l-1.5-1.6-1.9.7-1-1.8-2-.4-.3-2-1.8-1 .7-1.9L2.6 12l1.6-1.5-.7-1.9 1.8-1 .3-2 2-.4 1-1.8 1.9.7L12 1.6z"></path><path fill="#fff" d="M10.15 15.55 6.8 12.2l1.2-1.2 2.15 2.15 5.7-5.75 1.2 1.2-6.9 6.95z"></path></svg>';

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function getRoot() {
    return document.getElementById('ProductReviews');
  }

  function openModal() {
    if (!modal) return;
    modal.classList.add('is-open');
    document.body.classList.add('fp-sr-modal-open');
    resetFormState(false);
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('fp-sr-modal-open');
  }

  function setRating(value) {
    ratingInput.value = String(value || '');
    qsa('[data-fp-sr-star]', modal).forEach(function (btn) {
      var n = parseInt(btn.getAttribute('data-fp-sr-star'), 10);
      btn.classList.toggle('is-on', n <= value);
      btn.setAttribute('aria-pressed', n <= value ? 'true' : 'false');
    });
    var label = qs('[data-fp-sr-rating-label]', modal);
    if (label) {
      label.textContent = value
        ? value + ' / 5 stars'
        : 'Select 1 to 5 stars';
    }
  }

  function formatReviewDate(value) {
    if (!value) return '';
    var d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    try {
      return d.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  function normalizeReview(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var rating = parseInt(raw.rating, 10) || 0;
    if (rating < 1) rating = 1;
    if (rating > 5) rating = 5;
    var photos = [];
    if (Array.isArray(raw.photos)) {
      photos = raw.photos
        .map(function (p) {
          if (!p) return '';
          if (typeof p === 'string') return p;
          return p.url || p.src || '';
        })
        .filter(Boolean)
        .slice(0, maxPhotos);
    }
    return {
      id: raw.id || 'imp-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7),
      product_id: String(raw.product_id || (root && root.dataset.productId) || ''),
      sku: raw.sku || (root && root.dataset.sku) || '',
      asin: raw.asin || (root && root.dataset.asin) || '',
      rating: rating,
      title: raw.title || '',
      body: raw.body || raw.text || '',
      author_name: raw.author_name != null ? raw.author_name : (raw.author || raw.name || ''),
      author_email: raw.author_email || '',
      photos: photos,
      verified: raw.verified === true || raw.source === 'amazon' || raw.vp === true,
      vp: true,
      source: raw.source || 'amazon',
      status: raw.status || 'approved',
      created_at: raw.created_at || raw.date || new Date().toISOString()
    };
  }

  function renderPhotoThumbs() {
    var wrap = qs('[data-fp-sr-photo-list]', modal);
    if (!wrap) return;
    wrap.innerHTML = '';
    photos.forEach(function (item, index) {
      var el = document.createElement('div');
      el.className = 'fp-sr-photos-input__thumb';
      el.innerHTML =
        '<img alt="Review photo ' +
        (index + 1) +
        '" src="' +
        item.preview +
        '"><button type="button" aria-label="Remove photo">&times;</button>';
      el.querySelector('button').addEventListener('click', function () {
        photos.splice(index, 1);
        renderPhotoThumbs();
      });
      wrap.appendChild(el);
    });
  }

  function fileToCompressedDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onerror = reject;
      reader.onload = function () {
        var img = new Image();
        img.onload = function () {
          var max = 1200;
          var w = img.width;
          var h = img.height;
          if (w > max || h > max) {
            var scale = Math.min(max / w, max / h);
            w = Math.round(w * scale);
            h = Math.round(h * scale);
          }
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);
          var dataUrl = canvas.toDataURL('image/jpeg', 0.82);
          resolve({ preview: dataUrl, dataUrl: dataUrl, name: file.name || 'photo.jpg' });
        };
        img.onerror = reject;
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  }

  function onFilesSelected(fileList) {
    var files = Array.prototype.slice.call(fileList || []);
    var room = maxPhotos - photos.length;
    if (room <= 0) return;
    files.slice(0, room).forEach(function (file) {
      if (!file.type || file.type.indexOf('image/') !== 0) return;
      fileToCompressedDataUrl(file).then(function (item) {
        photos.push(item);
        renderPhotoThumbs();
      });
    });
  }

  function showError(msg) {
    var box = qs('[data-fp-sr-error]', modal);
    if (!box) return;
    box.textContent = msg || '';
    box.classList.toggle('is-visible', !!msg);
  }

  function resetFormState(clearFields) {
    showError('');
    qs('[data-fp-sr-success]', modal).classList.remove('is-visible');
    qs('[data-fp-sr-form-body]', modal).style.display = '';
    if (clearFields && form) {
      form.reset();
      photos = [];
      renderPhotoThumbs();
      setRating(0);
    }
  }

  function buildPayload() {
    var data = root.dataset;
    return {
      product_id: data.productId || '',
      sku: data.sku || '',
      asin: data.asin || '',
      product_title: data.productTitle || '',
      product_handle: data.productHandle || '',
      rating: parseInt(ratingInput.value, 10) || 0,
      title: (qs('[name="review_title"]', form).value || ''),
      body: (qs('[name="review_body"]', form).value || ''),
      author_name: (qs('[name="author_name"]', form).value || ''),
      author_email: (qs('[name="author_email"]', form).value || '').trim(),
      source: 'site',
      status: 'pending',
      verified: true,
      vp: true,
      photos: photos.map(function (p) {
        return p.dataUrl;
      }),
      // Front-end cannot customize date; always server/submit time.
      created_at: new Date().toISOString()
    };
  }

  function validate(payload) {
    if (!payload.rating || payload.rating < 1 || payload.rating > 5) {
      return 'Please select a star rating.';
    }
    if (!payload.body || payload.body.length < 10) {
      return 'Please write a review (at least 10 characters).';
    }
    if (!payload.author_name) {
      return 'Please enter your name.';
    }
    if (!payload.author_email || payload.author_email.indexOf('@') === -1) {
      return 'Please enter a valid email.';
    }
    return '';
  }

  function savePendingLocal(payload) {
    try {
      var key = 'fp_sr_pending_' + (payload.product_id || 'x');
      var list = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(list)) list = [];
      var copy = Object.assign({}, payload);
      copy.id = 'local-' + Date.now();
      copy.photos = (payload.photos || []).slice(0, maxPhotos);
      list.unshift(copy);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 20)));
      return copy;
    } catch (e) {
      return null;
    }
  }

  function appendCard(review, opts) {
    // Rating-only entries contribute to aggregate ratings, but have no card content.
    if (!String(review.title || '').trim() && !String(review.body || '').trim() && !(review.photos && review.photos.length)) return;
    opts = opts || {};
    var grid = qs('[data-fp-sr-grid]', root);
    var empty = qs('[data-fp-sr-empty]', root);
    if (!grid) return;
    if (empty) empty.style.display = 'none';

    if (review.id && grid.querySelector('[data-fp-sr-id="' + review.id + '"]')) {
      return;
    }

    var stars = '';
    for (var i = 1; i <= 5; i++) {
      stars +=
        '<span class="' +
        (i <= review.rating ? '' : 'is-empty') +
        '">' +
        STAR_SVG +
        '</span>';
    }

    var photosHtml = '';
    (review.photos || []).forEach(function (src) {
      if (!src) return;
      var safe = src.replace(/"/g, '&quot;');
      if (isVideoUrl(src)) {
        photosHtml +=
          '<button type="button" class="fp-sr__photo-btn" data-fp-sr-zoom="' +
          safe +
          '"><video class="fp-sr__photo fp-sr__photo--video" src="' +
          safe +
          '" muted playsinline preload="metadata" aria-label="Review video"></video></button>';
      } else {
        photosHtml +=
          '<button type="button" class="fp-sr__photo-btn" data-fp-sr-zoom="' +
          safe +
          '"><img class="fp-sr__photo" src="' +
          safe +
          '" alt="Review photo"></button>';
      }
    });

    var dateText = formatReviewDate(review.created_at);
    var isPending = review.status === 'pending';
    var isVerified =
      isPending ||
      review.verified === true ||
      review.source === 'amazon' ||
      review.vp === true;
    var badgeHtml = isVerified
      ? '<span class="fp-sr__verified" title="Verified purchase" aria-label="Verified purchase">' +
        VERIFIED_SVG +
        '</span>'
      : '';
    var card = document.createElement('article');
    card.className = 'fp-sr__card';
    card.setAttribute('data-fp-sr-card', '');
    if (review.id) card.setAttribute('data-fp-sr-id', review.id);
    card.innerHTML =
      '<div class="fp-sr__card-top">' +
      '<div class="fp-sr__card-copy">' +
      '<span class="fp-sr__author"></span>' +
      (dateText ? '<span class="fp-sr__date"></span>' : '') +
      '</div>' +
      '<div class="fp-sr__card-rating">' +
      '<span class="fp-sr__stars">' +
      stars +
      '</span>' +
      badgeHtml +
      '</div></div>' +
      (review.title ? '<h3 class="fp-sr__title"></h3>' : '') +
      '<p class="fp-sr__body"></p>' +
      (photosHtml ? '<div class="fp-sr__photos">' + photosHtml + '</div>' : '');

    card.querySelector('.fp-sr__author').textContent = review.author_name || '';
    if (dateText) card.querySelector('.fp-sr__date').textContent = dateText;
    if (review.title) card.querySelector('.fp-sr__title').textContent = review.title;
    card.querySelector('.fp-sr__body').textContent = review.body || '';

    if (opts.append) grid.appendChild(card);
    else grid.insertBefore(card, grid.firstChild);

    var countEl = qs('[data-fp-sr-count]', root);
    if (countEl) {
      var n = parseInt(countEl.getAttribute('data-count') || '0', 10) + 1;
      countEl.setAttribute('data-count', String(n));
      countEl.textContent = '(' + n + ')';
    }
  }


  function submitViaContactFallback(payload) {
    return new Promise(function (resolve) {
      var formEl = document.createElement('form');
      formEl.style.display = 'none';
      formEl.method = 'post';
      formEl.action = '/contact#fp-site-review';
      formEl.acceptCharset = 'UTF-8';

      function add(name, value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        formEl.appendChild(input);
      }

      add('form_type', 'contact');
      add('utf8', '✓');
      add(
        'contact[subject]',
        '[Product Review] ' + (payload.product_title || payload.sku || payload.product_id)
      );
      add(
        'contact[body]',
        [
          'NEW SITE REVIEW (pending moderation)',
          'product_id: ' + payload.product_id,
          'sku: ' + payload.sku,
          'asin: ' + payload.asin,
          'handle: ' + payload.product_handle,
          'rating: ' + payload.rating,
          'title: ' + payload.title,
          'author: ' + payload.author_name,
          'email: ' + payload.author_email,
          'photos: ' + (payload.photos || []).length,
          '',
          payload.body
        ].join('\n')
      );
      add('contact[email]', payload.author_email);
      add('contact[name]', payload.author_name);

      document.body.appendChild(formEl);
      // Do not actually navigate away; use fetch to contact if possible is unreliable.
      // Keep local pending + email via hidden iframe post.
      var iframe = document.createElement('iframe');
      iframe.name = 'fp_sr_contact_iframe';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      formEl.target = 'fp_sr_contact_iframe';
      formEl.submit();
      setTimeout(function () {
        resolve({ ok: true, mode: 'contact' });
      }, 400);
    });
  }

  function submitPayload(payload) {
    var endpoint = (root.dataset.submitUrl || '').trim();
    if (endpoint) {
      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (!res.ok) throw new Error('Submit failed');
        return res.json().catch(function () {
          return { ok: true };
        });
      });
    }
    return submitViaContactFallback(payload);
  }

  function onSubmit(e) {
    e.preventDefault();
    if (submitting) return;
    var payload = buildPayload();
    var err = validate(payload);
    if (err) {
      showError(err);
      return;
    }
    submitting = true;
    var btn = qs('[data-fp-sr-submit]', modal);
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Submitting…';
    }
    showError('');

    submitPayload(payload)
      .then(function () {
        try {
          var local = savePendingLocal(payload);
          if (local) appendCard(local);
        } catch (e) {
          // Submit already succeeded; do not surface card/local errors as submit failure.
        }
        var formBody = qs('[data-fp-sr-form-body]', modal);
        var success = qs('[data-fp-sr-success]', modal);
        if (formBody) formBody.style.display = 'none';
        if (success) success.classList.add('is-visible');
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Submit review';
        }
        submitting = false;
      })
      .catch(function () {
        showError('Could not submit review. Please try again.');
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Submit review';
        }
        submitting = false;
      });
  }

  function ensureViewer() {
    if (viewer) return viewer;
    viewer = document.createElement('div');
    viewer.className = 'fp-sr-viewer';
    viewer.setAttribute('data-fp-sr-viewer', '');
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.innerHTML =
      '<div class="fp-sr-viewer__panel">' +
      '<div class="fp-sr-viewer__top">' +
      '<button type="button" class="fp-sr-viewer__back" data-fp-sr-viewer-back>' +
      '<span class="fp-sr-viewer__back-icon" aria-hidden="true">&lsaquo;</span>' +
      '<span>See more</span>' +
      '</button>' +
      '<button type="button" class="fp-sr-viewer__close" data-fp-sr-viewer-close aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="fp-sr-viewer__main">' +
      '<div class="fp-sr-viewer__media">' +
      '<button type="button" class="fp-sr-viewer__nav fp-sr-viewer__nav--prev" data-fp-sr-viewer-prev aria-label="Previous photo">&lsaquo;</button>' +
      '<div class="fp-sr-viewer__hero-wrap" data-fp-sr-viewer-hero></div>' +
      '<button type="button" class="fp-sr-viewer__nav fp-sr-viewer__nav--next" data-fp-sr-viewer-next aria-label="Next photo">&rsaquo;</button>' +
      '</div>' +
      '<div class="fp-sr-viewer__copy">' +
      '<div class="fp-sr-viewer__author" data-fp-sr-viewer-author></div>' +
      '<div class="fp-sr-viewer__meta">' +
      '<span class="fp-sr-viewer__stars" data-fp-sr-viewer-stars></span>' +
      '<span class="fp-sr-viewer__verified" data-fp-sr-viewer-verified hidden>' +
      VERIFIED_SVG +
      '</span>' +
      '</div>' +
      '<div class="fp-sr-viewer__date" data-fp-sr-viewer-date></div>' +
      '<h3 class="fp-sr-viewer__title" data-fp-sr-viewer-title></h3>' +
      '<p class="fp-sr-viewer__body" data-fp-sr-viewer-body></p>' +
      '<div class="fp-sr-viewer__thumbs" data-fp-sr-viewer-thumbs></div>' +
      '</div></div></div>';
    document.body.appendChild(viewer);

    viewer.addEventListener('click', function (e) {
      var heroPhoto = e.target.closest('[data-fp-sr-viewer-hero] img.fp-sr-viewer__hero');
      var heroBox = e.target.closest('[data-fp-sr-viewer-hero]');
      var restoreFromBox =
        viewer.classList.contains('is-photo-full') &&
        heroBox &&
        !e.target.closest('video, a, button');
      if (heroPhoto || restoreFromBox) {
        e.preventDefault();
        e.stopPropagation();
        if (Date.now() - viewerSwipeAt < 700) return;
        viewer.classList.toggle('is-photo-full');
        return;
      }
      if (
        e.target === viewer ||
        e.target.closest('[data-fp-sr-viewer-close]') ||
        e.target.closest('[data-fp-sr-viewer-back]')
      ) {
        closeViewer();
      }
    });
    qs('[data-fp-sr-viewer-prev]', viewer).addEventListener('click', function (e) {
      e.stopPropagation();
      stepViewer(-1);
    });
    qs('[data-fp-sr-viewer-next]', viewer).addEventListener('click', function (e) {
      e.stopPropagation();
      stepViewer(1);
    });

    var media = qs('.fp-sr-viewer__media', viewer);
    media.addEventListener('touchstart', function (e) {
      if (e.target.closest('video, [data-fp-sr-video-play]')) return;
      if (!e.changedTouches || !e.changedTouches[0]) return;
      viewerTouchX = e.changedTouches[0].clientX;
    });
    media.addEventListener('touchend', function (e) {
      if (e.target.closest('video, [data-fp-sr-video-play]')) return;
      if (!e.changedTouches || !e.changedTouches[0]) return;
      var dx = e.changedTouches[0].clientX - viewerTouchX;
      if (Math.abs(dx) < 40) return;
      viewerSwipeAt = Date.now();
      stepViewer(dx > 0 ? -1 : 1);
    });
    return viewer;
  }

  function closeViewer() {
    if (!viewer) return;
    var video = qs('[data-fp-sr-viewer-hero] video', viewer);
    if (video) video.pause();
    viewer.classList.remove('is-open', 'is-photo-full');
    document.body.classList.remove('fp-sr-viewer-open');
  }

  function starHtml(rating) {
    var html = '';
    var i;
    for (i = 1; i <= 5; i++) {
      html += '<span class="' + (i <= rating ? '' : 'is-empty') + '">' + STAR_SVG + '</span>';
    }
    return html;
  }

  function renderViewerPhoto() {
    var hero = qs('[data-fp-sr-viewer-hero]', viewer);
    var previousVideo = qs('video', hero);
    if (previousVideo) previousVideo.pause();
    var prev = qs('[data-fp-sr-viewer-prev]', viewer);
    var next = qs('[data-fp-sr-viewer-next]', viewer);
    var thumbs = qsa('[data-fp-sr-viewer-thumbs] .fp-sr-viewer__thumb', viewer);
    if (!viewerPhotos.length) {
      hero.innerHTML = '';
      prev.hidden = true;
      next.hidden = true;
      return;
    }
    if (viewerIndex < 0) viewerIndex = viewerPhotos.length - 1;
    if (viewerIndex >= viewerPhotos.length) viewerIndex = 0;
    var src = viewerPhotos[viewerIndex];
    var safe = String(src).replace(/"/g, '&quot;');
    if (isVideoUrl(src)) {
      hero.innerHTML =
        '<video class="fp-sr-viewer__hero" src="' +
        safe +
        '" controls playsinline webkit-playsinline preload="metadata"></video>' +
        '<button type="button" class="fp-sr-viewer__play" data-fp-sr-video-play aria-label="Play review video">&#9654; Play video</button>' +
        '<p class="fp-sr-viewer__video-error" data-fp-sr-video-error role="status" hidden>Unable to play this video. <a href="' + safe + '" target="_blank" rel="noopener">Open video</a></p>';
      var video = qs('video', hero);
      var playButton = qs('[data-fp-sr-video-play]', hero);
      var videoError = qs('[data-fp-sr-video-error]', hero);
      playButton.addEventListener('click', function (event) {
        event.stopPropagation();
        videoError.hidden = true;
        // Call play directly inside the tap event for iOS user-gesture permission.
        var playback = video.play();
        if (playback && playback.catch) playback.catch(function () {
          playButton.hidden = false;
          videoError.hidden = false;
        });
      });
      video.addEventListener('playing', function () { playButton.hidden = true; videoError.hidden = true; });
      video.addEventListener('pause', function () { playButton.hidden = false; });
      video.addEventListener('ended', function () { playButton.hidden = false; });
      video.addEventListener('error', function () { videoError.hidden = false; });
    } else {
      hero.innerHTML =
        '<img class="fp-sr-viewer__hero" src="' + safe + '" alt="Review photo">';
    }
    var many = viewerPhotos.length > 1;
    prev.hidden = !many;
    next.hidden = !many;
    thumbs.forEach(function (el, i) {
      el.classList.toggle('is-active', i === viewerIndex);
    });
  }

  function stepViewer(delta) {
    if (viewerPhotos.length < 2) return;
    viewerIndex += delta;
    renderViewerPhoto();
  }

  function reviewFromCard(card) {
    var photos = [];
    qsa('[data-fp-sr-zoom]', card).forEach(function (el) {
      var src = el.getAttribute('data-fp-sr-zoom');
      if (src) photos.push(src);
    });
    if (!photos.length) {
      qsa('.fp-sr__photo', card).forEach(function (img) {
        var src = img.currentSrc || img.src;
        if (src) photos.push(src);
      });
    }
    var rating = 0;
    qsa('.fp-sr__stars > span', card).forEach(function (el) {
      if (!el.classList.contains('is-empty')) rating += 1;
    });
    var titleEl = qs('.fp-sr__title', card);
    var bodyEl = qs('.fp-sr__body', card);
    var authorEl = qs('.fp-sr__author', card);
    var dateEl = qs('.fp-sr__date', card);
    return {
      author: authorEl ? authorEl.textContent : '',
      date: dateEl ? dateEl.textContent : '',
      title: titleEl ? titleEl.textContent : '',
      body: bodyEl ? bodyEl.textContent : '',
      rating: rating,
      verified: !!qs('.fp-sr__verified', card),
      photos: photos
    };
  }

  function openViewer(review, photoIndex) {
    ensureViewer();
    viewerPhotos = review.photos || [];
    viewerIndex = photoIndex || 0;
    viewer.classList.toggle('is-text-only', viewerPhotos.length === 0);
    qs('[data-fp-sr-viewer-author]', viewer).textContent = review.author || '';
    qs('[data-fp-sr-viewer-stars]', viewer).innerHTML = starHtml(review.rating || 0);
    var verified = qs('[data-fp-sr-viewer-verified]', viewer);
    if (review.verified) verified.removeAttribute('hidden');
    else verified.setAttribute('hidden', '');
    var dateEl = qs('[data-fp-sr-viewer-date]', viewer);
    dateEl.textContent = review.date || '';
    dateEl.style.display = review.date ? '' : 'none';
    var titleEl = qs('[data-fp-sr-viewer-title]', viewer);
    titleEl.textContent = review.title || '';
    titleEl.style.display = review.title ? '' : 'none';
    qs('[data-fp-sr-viewer-body]', viewer).textContent = review.body || '';

    var thumbs = qs('[data-fp-sr-viewer-thumbs]', viewer);
    thumbs.innerHTML = '';
    viewerPhotos.forEach(function (src, i) {
      var thumb;
      if (isVideoUrl(src)) {
        thumb = document.createElement('video');
        thumb.muted = true;
        thumb.playsInline = true;
        thumb.preload = 'metadata';
      } else {
        thumb = document.createElement('img');
        thumb.alt = 'Photo ' + (i + 1);
      }
      thumb.className = 'fp-sr-viewer__thumb';
      thumb.src = src;
      thumb.addEventListener('click', function (e) {
        e.stopPropagation();
        viewerIndex = i;
        renderViewerPhoto();
      });
      thumbs.appendChild(thumb);
    });

    renderViewerPhoto();
    viewer.classList.add('is-open');
    document.body.classList.add('fp-sr-viewer-open');
  }

  function hydratePendingFromLocal() {
    if (!root) return;
    var pid = root.dataset.productId || '';
    if (!pid) return;
    try {
      var list = JSON.parse(localStorage.getItem('fp_sr_pending_' + pid) || '[]');
      if (!Array.isArray(list)) return;
      list
        .slice()
        .reverse()
        .forEach(function (review) {
          appendCard(review);
        });
    } catch (e) {}
  }

  function bindReviewMasonry() {
    var grid = qs('[data-fp-sr-grid]', root);
    if (!grid) return;
    var desktop = window.matchMedia('(min-width: 750px)');
    var scheduled = false;
    function layout() {
      scheduled = false;
      var cards = qsa('.fp-sr__card', grid);
      var active = desktop.matches && grid.clientWidth > 0 && cards.length > 0;
      grid.classList.toggle('fp-sr__grid--masonry', active);
      if (!active) {
        grid.style.height = '';
        cards.forEach(function (card) { card.style.top = ''; card.style.left = ''; });
        return;
      }
      var heights = [0, 0];
      cards.forEach(function (card) {
        var column = heights[0] <= heights[1] ? 0 : 1;
        card.style.left = column ? 'calc(50% + 7px)' : '0';
        card.style.top = heights[column] + 'px';
        heights[column] += card.offsetHeight + 14;
      });
      grid.style.height = Math.max(0, Math.max(heights[0], heights[1]) - 14) + 'px';
    }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(layout);
    }
    var sizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;
    var observed = [];
    function watchCards() {
      var cards = qsa('.fp-sr__card', grid);
      if (sizeObserver) {
        observed.forEach(function (card) { if (cards.indexOf(card) < 0) sizeObserver.unobserve(card); });
        cards.forEach(function (card) { if (observed.indexOf(card) < 0) sizeObserver.observe(card); });
      }
      observed = cards;
      schedule();
    }
    if (window.ResizeObserver) {
      var lastWidth = -1;
      new ResizeObserver(function () {
        if (grid.clientWidth !== lastWidth) { lastWidth = grid.clientWidth; schedule(); }
      }).observe(grid);
    }
    new MutationObserver(watchCards).observe(grid, { childList: true });
    grid.addEventListener('load', schedule, true);
    grid.addEventListener('loadedmetadata', schedule, true);
    window.addEventListener('resize', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    watchCards();
  }

  function bind() {
    root = getRoot();
    if (!root || root.getAttribute('data-fp-sr-bound') === '1') return;
    root.setAttribute('data-fp-sr-bound', '1');

    modal = qs('[data-fp-sr-modal]', root) || qs('[data-fp-sr-modal]');
    form = modal ? qs('[data-fp-sr-form]', modal) : null;
    ratingInput = form ? qs('[name="rating"]', form) : null;

    document.addEventListener(
      'click',
      function (e) {
        var openBtn = e.target.closest('[data-fp-write-review], a[href="#ProductReviewsWrite"]');
        if (openBtn) {
          e.preventDefault();
          openModal();
          return;
        }
        var card = e.target.closest('#ProductReviews .fp-sr__card');
        if (card) {
          e.preventDefault();
          e.stopPropagation();
          var photoEl = e.target.closest('.fp-sr__photo, [data-fp-sr-zoom]');
          var review = reviewFromCard(card);
          var idx = 0;
          if (photoEl) {
            var src = photoEl.getAttribute('data-fp-sr-zoom') || photoEl.src;
            var found = review.photos.indexOf(src);
            if (found < 0 && photoEl.currentSrc) found = review.photos.indexOf(photoEl.currentSrc);
            if (found >= 0) idx = found;
          }
          openViewer(review, idx);
        }
      },
      true
    );

    if (modal) {
      qsa('[data-fp-sr-close]', modal).forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
      qsa('[data-fp-sr-star]', modal).forEach(function (btn) {
        btn.addEventListener('click', function () {
          setRating(parseInt(btn.getAttribute('data-fp-sr-star'), 10));
        });
      });
      var fileInput = qs('[data-fp-sr-file]', modal);
      if (fileInput) {
        fileInput.addEventListener('change', function () {
          onFilesSelected(fileInput.files);
          fileInput.value = '';
        });
      }
    }
    if (form) form.addEventListener('submit', onSubmit);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (viewer && viewer.classList.contains('is-open')) {
          if (viewer.classList.contains('is-photo-full')) {
            viewer.classList.remove('is-photo-full');
            return;
          }
          closeViewer();
          return;
        }
        closeModal();
        return;
      }
      if (!viewer || !viewer.classList.contains('is-open')) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        stepViewer(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        stepViewer(1);
      }
    });

    hydratePendingFromLocal();
    bindReviewMasonry();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
